import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormHelperText,
    Grid2,
    IconButton,
    TextField,
    useTheme,
} from "@mui/material";
import { Formik } from "formik";
import * as React from "react";
import { IoMdClose } from "react-icons/io";
import { useUpdateImageGalleryStatusMutation } from "store/slices/apis/imageGallerySlice";
import * as Yup from "yup";

export default function RejectImageApproval(props) {
    const { open, cancel, rowData, openNotification, clearData } =
        props;
    const theme = useTheme();
    const [updateImageGallery, updatImageGalleryRes] = useUpdateImageGalleryStatusMutation();
    const [formData, setFormData] = React.useState({
        Comment: "",
    });

    const handleSubmit = (values) => {
        const formdata = new FormData();
        formdata.append("Status", "Rejected");
        formdata.append("Comment", values?.Comment);
        if (rowData != null) {
            rowData?.map((value, key) => {
                formdata.append('ids', value)
            })
        }

        updateImageGallery(formdata);
    };

    React.useEffect(() => {
        if (updatImageGalleryRes?.isSuccess) {
            if (updatImageGalleryRes?.data?.status == "success") {
                openNotification(updatImageGalleryRes?.data?.message, "success");
                cancel();
                clearData();
            } else {
                openNotification(updatImageGalleryRes?.data?.message, "error");
            }
        }
    }, [updatImageGalleryRes?.isSuccess]);

    const validationSchema = Yup.object({
        Comment: Yup.string().required("Comment field is required."),
    });

    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={cancel}
                disableEnforceFocus
                disableRestoreFocus
                aria-labelledby="draggable-dialog-title"
                fullWidth={true}
                maxWidth={"sm"}
            >
                <DialogTitle
                    sx={{
                        fontWeight: 500,
                        fontSize: "20px",
                        color: "#252525",
                        paddingBottom: 0,
                    }}
                    id="draggable-dialog-title"
                >
                    Reject
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={cancel}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <IoMdClose style={{ fontSize: "20px" }} />
                </IconButton>
                <DialogContent>
                    <DialogContentText
                        sx={{ fontWeight: 400, fontSize: "16px", color: "#474747" }}
                    >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                            enableReinitialize
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                isSubmitting,
                                setFieldValue,
                                setTouched,
                            }) => (
                                <form onSubmit={handleSubmit}>
                                    <Grid2 size={12}>
                                        <DialogContentText
                                            sx={{
                                                fontWeight: 400,
                                                fontSize: "16px",
                                                color: "#474747",
                                                marginBottom: "20px",
                                            }}
                                        >
                                            Are you sure you want to reject these images ?
                                            This action is permanent.
                                        </DialogContentText>
                                        <TextField
                                            id="outlined-multiline-static"
                                            label="Comment"
                                            name="Comment"
                                            multiline
                                            fullWidth
                                            value={values?.Comment}
                                            onChange={handleChange}
                                            onBlur={() => setTouched({ ...touched, Comment: true })}
                                            slotProps={{ inputLabel: { shrink: true } }}
                                            variant="filled"
                                        />
                                        {touched?.Comment && errors?.Comment && (
                                            <FormHelperText
                                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                                            >{`${errors?.Comment}`}</FormHelperText>
                                        )}
                                    </Grid2>

                                    <Grid2 size={12}>
                                        <DialogActions>
                                            <Button
                                                type="submit"
                                                loading={updatImageGalleryRes?.isLoading}
                                                variant="contained"
                                                sx={{
                                                    backgroundColor: "#C52A1A",
                                                    color: "#fff",
                                                    fontSize: "16px",
                                                    fontWeight: "500",
                                                    textTransform: "none",
                                                }}
                                            >
                                                Reject
                                            </Button>
                                        </DialogActions>
                                    </Grid2>
                                </form>
                            )}
                        </Formik>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
}
